var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("บัญชีแสดงสัญญา \n        ")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.caNo,
              expression: "caNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true, max: 20 },
              expression: "{required:true,max:20}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("caNo") },
          attrs: { name: "caNo", type: "number", placeholder: "" },
          domProps: { value: _vm.caNo },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.caNo = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("caNo"),
                expression: "errors.has('caNo')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v("กรอก บัญชีแสดงสัญญา")]
        )
      ]),
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("เครื่องวัดหน่วยไฟฟ้า")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.meterNo,
              expression: "meterNo"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: { required: true, max: 20 },
              expression: "{required:true,max:20}"
            }
          ],
          staticClass: "form-control",
          class: { input: true, "is-danger": _vm.errors.has("meterNo") },
          attrs: { name: "meterNo", type: "number", placeholder: "" },
          domProps: { value: _vm.meterNo },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.meterNo = $event.target.value
            }
          }
        }),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("meterNo"),
                expression: "errors.has('meterNo')"
              }
            ],
            staticClass: "help is-danger"
          },
          [_vm._v("กรอก เครื่องวัดหน่วยไฟฟ้า")]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }